import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { firstValueFrom, from, Observable } from 'rxjs';
import { EventsService } from './events.service';
import { GamerecordService } from './gamerecord.service';
import { SettingsService } from './settings.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserFeedbackService } from './user-feedback.service';
import { TranslateService } from '@ngx-translate/core';
import { GenericDialogComponent } from './generic-dialog/generic-dialog.component';
import { ForgotPasswordDialogComponent } from '../auth/forgot-password-dialog/forgot-password-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  user$: Observable<any>

  constructor(
    private afAuth: AngularFireAuth,
    private http: HttpClient,
    private userFeddback: UserFeedbackService,
    private translateService: TranslateService
  ) {
    this.user$ = this.afAuth.authState
  }

  signInWithEmailAndPassword(cred) {
    return from(this.afAuth.signInWithEmailAndPassword(cred.email, cred.password))

  }

  sendPasswordResetEmail(email:string){
    return this.afAuth.sendPasswordResetEmail(email)
  }

  async signOut() {
    await this.afAuth.signOut()
    return Promise.resolve()
  }

  initResetPassword(email: string): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(
        `${environment.apiURL}/user/password/initiate`,
        { email }, { observe: 'response' }
      )
    );
  }

  completeResetPassword(oobCode: string, newPassword: string): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(
        `${environment.apiURL}/user/password/complete`,
        { oobCode, newPassword }, { observe: 'response' }
      )
    );
  }

  async callForgotPassword(email:string){
    const title = this.translateService.instant('AUTH.Password_forgoten')
    
    if(email){
      this.userFeddback.loading.emit(true)
      this.callGetEmailToResetPass(email)

    }else{
      const message = this.translateService.instant('AUTH.reset_password_email')

      this.userFeddback.showDialog.emit({
        entryComponent: ForgotPasswordDialogComponent,
        title,
        message,
        cancleCallback: async () => { },
        positiveCallback: async (data)=> {
          this.userFeddback.loading.emit(true)
          this.callGetEmailToResetPass(data)
        }
      })
    }
  }


  async callGetEmailToResetPass(email:string){
    const info = this.translateService.instant('resetPasswordLink_send_ok')
    const title = this.translateService.instant('AUTH.Password_forgoten')
    const failed = this.translateService.instant('resetPasswordLink_send_failed')

    try {
      const response = await this.initResetPassword(email);
      if( response?.body?.result === 'success'){
        this.userFeddback.loading.emit(false)
        const message = info +' :   ' + email
        this.userFeddback.showDialog.emit({
          entryComponent: GenericDialogComponent,
          title,
          message,
          positiveCallback: async ()=> { this.userFeddback.loading.emit(false) }
        })
      }
    } catch(e) {
      console.log(e)
      this.userFeddback.showSnackBar.emit(failed)
      this.userFeddback.loading.emit(false)
    } finally {
      this.userFeddback.loading.emit(false)
    }
  }
}
